<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="区域编码" prop="areaId" >
        <a-input-number v-model="form.areaId" :min="0" :step="1" :precision="0" placeholder="请输入区域编码" />
      </a-form-model-item>
      <a-form-model-item label="区域名称" prop="areaName" >
        <a-input v-model="form.areaName" placeholder="请输入区域名称"/>
      </a-form-model-item>
      <a-form-model-item label="区域全称" prop="fullName" >
        <a-input v-model="form.fullName" placeholder="请输入区域全称" />
      </a-form-model-item>
      <a-form-model-item label="上一级区域编码" prop="parentId" >
        <a-input-number v-model="form.parentId" :min="0" :step="1" :precision="0" placeholder="请输入上一级区域编码" />
      </a-form-model-item>
      <a-form-model-item label="层级" prop="level">
        <a-select style="width: 100%" v-model="form.level" placeholder="请选择层级" allow-clear>
          <a-select-option :value="1">1</a-select-option>
          <a-select-option :value="2">2</a-select-option>
          <a-select-option :value="3">3</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="城市线级" prop="tierCities" >
        <a-select style="width: 100%" v-model="form.tierCities" placeholder="请选择城市线级" allow-clear>
          <a-select-option :value="1">一线</a-select-option>
          <a-select-option :value="1.5">新一线</a-select-option>
          <a-select-option :value="2">二线</a-select-option>
          <a-select-option :value="3">三线</a-select-option>
          <a-select-option :value="4">四线</a-select-option>
          <a-select-option :value="5">五线</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="中心点经度" prop="centerLongitude" >
        <a-input v-model="form.centerLongitude" placeholder="请输入中心点经度"/>
      </a-form-model-item>
      <a-form-model-item label="中心点纬度" prop="centerLatitude" >
        <a-input v-model="form.centerLatitude" placeholder="请输入中心点纬度"/>
      </a-form-model-item>
      <!--热门城市-->
      <a-form-model-item label="是否热门" prop="isHot">
        <a-switch v-model="form.isHot" />
      </a-form-model-item>
      <a-form-model-item label="是否显示" prop="isShow">
        <a-switch v-model="form.isShow" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否显示" prop="isShow">-->
<!--        <a-radio-group v-model="form.isShow" button-style="solid">-->
<!--          <a-radio-button v-for="(d, index) in isShowOptions" :key="index" :value="d.value">{{ d.label }}</a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="${comment}" prop="level" >
        <a-input v-model="form.level" placeholder="请输入${comment}" />
      </a-form-model-item>
      <a-form-model-item label="中心点的经纬度" prop="centerLatLon" >
        <a-input v-model="form.centerLatLon" placeholder="请输入中心点的经纬度" />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getArea, addArea, updateArea } from '@/api/extra/area'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  props: {
    isShowOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        areaId: null,
        areaName: null,
        fullName: null,
        parentId: null,
        tierCities: null,
        isHot: null,
        isShow: null,
        level: null,
        centerLongitude: null,
        centerLatitude: null,
        centerLatLon: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        areaId: [
          { required: true, message: '请输入区域编码', trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: '请输入区域名称', trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: '请输入区域全称', trigger: 'blur' }
        ],
        // tierCities: [
        //   { required: true, message: '请输入城市线级', trigger: 'blur' }
        // ],
        centerLongitude: [
          { required: true, message: '请输入中心点经度', trigger: 'blur' }
        ],
        centerLatitude: [
          { required: true, message: '请输入中心点纬度', trigger: 'blur' }
        ],
        isHot: [
          { required: true, message: '是否热门不能为空', trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: '是否显示不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: { ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        areaId: null,
        areaName: null,
        fullName: null,
        parentId: null,
        tierCities: null,
        isHot: null,
        isShow: null,
        level: null,
        centerLongitude: null,
        centerLatitude: null,
        centerLatLon: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const areaId = row ? row.areaId : ids
      getArea(areaId).then(response => {
        this.form = response.data
        var centerLatLon = response.data.centerLatLon.split(',')
        this.form.centerLongitude = centerLatLon[0]
        this.form.centerLatitude = centerLatLon[1]
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.centerLatLon = this.form.centerLongitude + ',' + this.form.centerLatitude
          addArea(this.form).then(response => {
            this.$message.success(
              '操作成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
